import moment from 'moment';
export default function isPaxSixteen(value) {
    return value === '' || moment().diff(moment(value), 'years') >= 16;
}
